import type * as React from 'react';
import { type IConfigurationCardTreeEntry } from '../ConfigurationCardContext.tsx';

/**
 * Converte l'albero delle entry registrate nel formato `items` dell'`Anchor` di
 * Ant Design (link annidati con `href="#<id>"`). Usato dalla navigazione
 * laterale del `ConfigurationCardGroup` non-dense.
 */
export function mapTreeToAnchorItems(items: IConfigurationCardTreeEntry[]): {
  key: string;
  href: string;
  title: React.ReactNode;
  children?: { key: string; href: string; title: React.ReactNode }[];
}[] {
  return items.map(entry => ({
    key: entry.id,
    href: `#${entry.id}`,
    title: entry.title,
    children: entry.children ? mapTreeToAnchorItems(entry.children) : undefined,
  }));
}
